import React, { useState, useEffect } from 'react';
import { Colors, AppWrapper } from '@capcenter/shared';
import {RTB, RTBImage, GlobalIcons, ImageCapCenterHQ} from '@capcenter/shared-legacy';
import { LocationsData } from '@capcenter/shared-service-map';
import { ServiceArea } from './ServiceArea'
import Locations from './Locations';
import Location from './Location';
import '@capcenter/shared-legacy/src/constants/GlobalStyles.scss';
import { initializeApp, RemoteConfigFetcher } from '@capcenter/firebase-service';

GlobalIcons();

initializeApp(window.location.hostname);

export const remoteConfig: RemoteConfigFetcher = new RemoteConfigFetcher(
  {
    minimumFetchIntervalMillis: 360000,
    fetchTimeoutMillis: 10000,
  },
  {
    expandedClientRelationsHours: true,
  },
);

function ContactUs() {
  const [locationsData, setLocationsData] = useState(LocationsData);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      await remoteConfig.fetchAndActivate();

      const expandedClientRelationsHoursFlag = remoteConfig.getConfigBoolean('expandedClientRelationsHours');

      if (!expandedClientRelationsHoursFlag) {
        locationsData[0].opens = '8';
        locationsData[0].closes = '5:30';
      }

      setLocationsData(locationsData);
      setLoaded(true);
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const LocationsDataNoCR: Array<any> = Array.from(locationsData).splice(1, 100);

  return (
    <React.Fragment>
      {loaded && (
        <AppWrapper app="contact">
          <>
            <div className="container">
              <br className="d-none d-lg-block" />

              <div className="row">
                <div className="col-12 col-md-8 offset-md-2 d-block d-lg-none" style={{ marginBottom: 15 }}>
                  <Location {...locationsData[0]} />
                </div>

                <div className="d-none d-lg-block col-lg-6 col-xl-5">
                  <Locations locations={locationsData} />
                </div>

                <div className="col-12 col-lg-6 col-xl-7">
                  <ServiceArea locations={locationsData} />
                  <br />
                </div>

                <div className="col-12 col-md-8 offset-md-2 d-block d-lg-none" style={{ marginBottom: 15 }}>
                  <Locations locations={LocationsDataNoCR} />
                </div>
              </div>
            </div>
            <div style={{ backgroundColor: Colors.gray350, paddingBottom: 15 }} />
            <RTB
              title="Do you have questions?"
              text={['Please contact us via chat, phone <a href="tel:18009685444">1-800-968-5844</a>, email <a href="mailto:customerservice@capcenter.com">customerservice@capcenter.com</a>, submit a <a href="/forms/contact-client-relations">form inquiry</a>, or search our <a href="https://faq.capcenter.com/" target="_blank">knowledge base</a> of commonly asked questions.']}
            >
              <RTBImage image={ImageCapCenterHQ} />
            </RTB>
          </>
        </AppWrapper>
      )}
    </React.Fragment>
  );
}

export default ContactUs;
